import { useNavigate } from "@tanstack/react-router";
import { AlertCircle, Box, Clock, Truck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn, formatNumber } from "@/lib/utils";
import { fqcStageOf } from "@/lib/fqc-stage";

const BASE = "text-[10px] font-semibold px-1.5 py-0 h-5 flex items-center gap-1 max-w-fit whitespace-nowrap";

/** Tình trạng lô sau KCS Đạt, hiện ngay dưới số phiếu: Chờ đóng gói / Chờ giao hàng / Chờ xe / phiếu giao */
export function FqcStageBadge({ item }: { item: any }) {
  const navigate = useNavigate();
  const stage = fqcStageOf(item);
  const info = item?.deliveryInfo || {};
  if (stage === "PENDING_RECEIPT")
    return (
      <Badge
        data-testid="fqc-stage"
        className={cn(BASE, "bg-amber-50 text-amber-800 border-amber-300 hover:bg-amber-50")}
        title="Lô KCS Đạt đã bàn giao cho Sản xuất: chờ đóng gói, in tem thùng và nhập kho"
      >
        <Box className="w-3 h-3 text-amber-600 shrink-0" /> Chờ đóng gói
      </Badge>
    );
  if (stage === "WAITING_DELIVERY" || stage === "READY_FOR_DISPATCH") {
    const partial = Number(info.lotDeliveredQty) > 0;
    const ready = stage === "READY_FOR_DISPATCH";
    return (
      <Badge
        data-testid="fqc-stage"
        className={cn(
          BASE,
          ready
            ? "bg-sky-50 text-sky-700 border-sky-300 hover:bg-sky-50"
            : "bg-violet-50 text-violet-800 border-violet-300 hover:bg-violet-50",
        )}
        title={partial ? `Lô đã lên phiếu giao ${formatNumber(info.lotDeliveredQty)}, còn ${formatNumber(info.lotRemainingQty)} chưa giao` : undefined}
      >
        {ready ? <Clock className="w-3 h-3 text-sky-600 shrink-0" /> : <AlertCircle className="w-3 h-3 text-violet-600 shrink-0" />}
        {ready ? "Chờ xe" : "Chờ giao hàng"}
        {partial && <span className="font-mono">· còn {formatNumber(info.lotRemainingQty)}</span>}
      </Badge>
    );
  }
  if (stage === "HAS_DELIVERY") {
    const code = info.deliveryCode || info.latestDelivery?.deliveryId || info.deliveryId;
    return (
      <Badge
        data-testid="fqc-stage"
        className={cn(BASE, "bg-emerald-50 text-emerald-700 border-emerald-300 cursor-pointer hover:bg-emerald-100")}
        onClick={(e) => {
          e.stopPropagation();
          if (code) navigate({ to: "/delivery/$deliveryId", params: { deliveryId: code } });
        }}
        title="Bấm để xem phiếu giao hàng"
      >
        <Truck className="w-3 h-3 text-emerald-600 shrink-0" />
        {code ? `Giao ${code}` : "Đã lên phiếu giao"}
      </Badge>
    );
  }
  return null;
}
